module.exports = __webpack_public_path__ + "static/img/database_active.21e12025.svg";